<template>
  <a-card :bordered="false">
    <a-row>
      <a-col :span="8">
        <a-button type="primary" @click="openModel">添加供应商</a-button>
      </a-col>
      <a-col :span="8" :offset="8" style="text-align: right;">
        <a-button @click="goRules">同步规则</a-button>
      </a-col>
    </a-row>
    <custom-page-table
      ref="table"
      :queryParams="queryParams"
      style="margin-top:16px;"
      :columns="columns"
      :request-promise="getListPromise"
    >
      <span slot="status" slot-scope="rowItem">
        <span>{{ rowItem.record.status === 1 ? '启用' : '禁用' }}</span>
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="editEvent(rowItem.record)">编辑</a>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.status === 0" @click="onUpdateEvent(rowItem.record.id,1)">启用</a>
        <a v-else style="color:red;" @click="onUpdateEvent(rowItem.record.id,0)">禁用</a>
        <a-divider type="vertical"/>
        <a @click="showSelectedEvent(rowItem.record.id)">选择商品类型</a>
        <a-divider type="vertical"/>
        <a @click="goDistributionMember(rowItem.record.id)">关联分销员</a>
      </span>
    </custom-page-table>
    <a-modal :title="id?'编辑供应商':'添加供应商'" :width="800" :footer="null"
             :afterClose="afterClose"
             :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="供应商名称" prop="supplierName">
          <a-input v-model.trim="ruleForm.supplierName" :maxLength="30"
                   placeholder="仅用于区分标识数据来源，30个字内"></a-input>
        </a-form-model-item>
        <a-form-model-item label="接口地址(URL)" prop="supplierUrl">
          <a-input v-model.trim="ruleForm.supplierUrl" placeholder="请输入" :maxLength="500"></a-input>
        </a-form-model-item>
        <a-form-model-item label="图片域名地址" prop="supplierImageUrl">
          <a-input v-model.trim="ruleForm.supplierImageUrl" placeholder="请输入" :maxLength="500"></a-input>
        </a-form-model-item>
        <a-form-model-item label="旅行社id(TaGuid)" prop="supplierAccountId">
          <a-input v-model.trim="ruleForm.supplierAccountId" placeholder="请输入" :maxLength="500"></a-input>
        </a-form-model-item>
        <a-form-model-item label="用户名(UserID)" prop="supplierKeyId">
          <a-input v-model.trim="ruleForm.supplierKeyId" placeholder="请输入" :maxLength="500"></a-input>
        </a-form-model-item>
        <a-form-model-item label="密码(PassWord)" prop="supplierPassword">
          <a-input v-model.trim="ruleForm.supplierPassword" placeholder="请输入" :maxLength="500"></a-input>
        </a-form-model-item>
        <a-form-model-item label="订单直连规则" required>
          <a-radio-group v-model="ruleForm.supplierOrderDirectRule">
            <a-radio :value="0">
              未关联分销员及用户名密码或密码错误时，使用本页面默认用户名密码下单
            </a-radio>
            <a-radio :value="1">
              未关联分销员及用户名密码或密码错误时，直接拒绝订单
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit" :loading="loading" style="width: 150px;margin-right: 20px;">
            提交
          </a-button>
          <a-button @click="handleCancel">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="选择商品类型" :width="666" :footer="null"
             :afterClose="afterClose"
             :visible="showVisible" @cancel="handleSelectedCancel">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="商品类型对应">
          <div>
            本系统“国内跟团” =
            <a-select
              mode="multiple"
              style="width: 230px"
              :value="value1"
              placeholder="请选择一起行分类（多选）"
              @change="handleChange"
              :allowClear="true"
            >
              <a-select-option v-for="(item,index) in filteredOptions" :key="index" :value="item.PackageTypeid">
                {{ item.TypeName }}
              </a-select-option>
            </a-select>
          </div>
          <div>
            本系统“出境跟团” =
            <a-select
              :allowClear="true"
              mode="multiple"
              style="width: 230px"
              placeholder="请选择一起行分类（多选）"
              @change="handleChange2"
              :value="value2"
            >
              <a-select-option v-for="(item,index) in filteredOptions2" :key="index" :value="item.PackageTypeid">
                {{ item.TypeName }}
              </a-select-option>
            </a-select>
          </div>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="submitData" style="width: 150px;margin-right: 20px;">提交</a-button>
          <a-button @click="handleSelectedCancel">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
const OPTIONS = ['百货', '抢购', '跟团', '酒店', '门票']
export default {
  name: 'AssociatedAccount',
  data() {
    return {
      options1: [],
      options2: [],
      value1: [],
      value2: [],
      queryParams: {},
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '旅行社 id(TaGuid)',
          dataIndex: 'supplierAccountId'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '300px',
          fixed: 'right'
        }
      ],
      visible: false,
      ruleForm: {
        supplierOrderDirectRule: 0
      },
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rules: {
        supplierName: [{ required: true, message: '请输入供应商名称', trigger: ['blur', 'change'] }],
        supplierUrl: [{ required: true, message: '请输入接口地址(URL)', trigger: ['blur', 'change'] }],
        supplierAccountId: [{ required: true, message: '请输入旅行社id(TaGuid)', trigger: ['blur', 'change'] }],
        supplierKeyId: [{ required: true, message: '请输入用户名(UserID)', trigger: ['blur', 'change'] }],
        supplierPassword: [{ required: true, message: '请输入密码(PassWord)', trigger: ['blur', 'change'] }],
        supplierImageUrl: [{ required: true, message: '请输入图片域名地址', trigger: ['blur', 'change'] }]
      },
      showVisible: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      id: '',
      options: []
    }
  },
  computed: {
    filteredOptions() {
      return this.options.filter(i => !this.value2.includes(i.PackageTypeid))
    },
    filteredOptions2() {
      return this.options.filter(i => !this.value1.includes(i.PackageTypeid))
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'SynchronousProducts', title: '同步产品' },
      { name: 'DirectOrdersList', title: '订单直连' },
      { name: 'TogetherAccount', title: '关联账号' }
    ])

  },
  methods: {
    goDistributionMember(id) {
      let query = {
        serverId: this.$route.query.serverId,
        serverUniqueId: this.$route.query.serverUniqueId,
        accountId: id
      }
      this.openNewPage('DistributionMember', query)
    },
    showSelectedEvent(id) {
      this.value1 = []
      this.value2 = []
      this.id = id
      this.options = []
      this.getCategory(id)
      this.getSupplierDetails(id, 2)
    },
    handleSelectedCancel() {
      this.showVisible = false
    },
    handleChange(value) {
      this.value1 = value
    },
    handleChange2(value) {
      this.value2 = value
    },
    handleCancel() {
      this.visible = false
    },
    afterClose() {
      this.id = ''
    },
    getListPromise(params) {
      let param = {
        ...params,
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      return this.getHttpServices().getServerApiService().post('travel/supplier/list', param)
    },
    submitEvent() {
      this.loading = true
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        supplierAccountId: this.ruleForm.supplierAccountId,
        supplierKeyId: this.ruleForm.supplierKeyId,
        supplierName: this.ruleForm.supplierName,
        supplierPassword: this.ruleForm.supplierPassword,
        supplierUrl: this.ruleForm.supplierUrl,
        supplierImageUrl: this.ruleForm.supplierImageUrl,
        supplierOrderDirectRule: this.ruleForm.supplierOrderDirectRule
      }
      if (this.id) {
        params.id = this.id
      }
      let msg = this.id ? '编辑成功' : '成功添加'
      this.getHttpServices().getServerApiService().post('travel/supplier/add', params)
        .then(res => {
          this.$message.success(msg)
          this.visible = false
          this.showVisible = false
          this.loading = false
          this.$refs.table.refresh(true)
        }).catch(reason => {
        this.loading = false
        this.showNetWorkErrorMessage(reason)
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitEvent()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      if (this.value1 && this.value1.length > 0) {
        params.inBound = this.value1.join(',')
      }
      if (this.value2 && this.value2.length > 0) {
        params.outBound = this.value2.join(',')
      }
      if (this.id) {
        params.id = this.id
      }
      this.getHttpServices().getServerApiService().post('travel/supplier/updateType', params)
        .then(res => {
          this.$message.success('添加成功')
          this.showVisible = false
          this.$refs.table.refresh(true)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    getCategory(id) {
      let url = 'travel/supplier/category/' + id
      this.getHttpServices().getServerApiService().get(url)
        .then(res => {
          this.options = res
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    openModel() {
      this.ruleForm = {
        supplierOrderDirectRule: 0
      }
      this.visible = true
    },
    goRules() {
      this.$router.push({
        name: 'SynchronizationRules',
        query: {
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    editEvent(record) {
      this.id = record.id
      this.getSupplierDetails(record.id, 1)
    },
    getSupplierDetails(id, type) {
      let url = 'travel/supplier/' + id
      this.getHttpServices().getServerApiService().get(url)
        .then(res => {
          this.ruleForm = { ...res }
          this.value1 = res.inBound ? res.inBound.split(',') : []
          this.value2 = res.outBound ? res.outBound.split(',') : []
          if (type == 1) {
            this.visible = true
          } else {
            this.showVisible = true
          }
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    onUpdateEvent(id, type) {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: id,
        status: type
      }
      this.getHttpServices().getServerApiService().post('travel/supplier/status', params)
        .then(res => {
          this.showVisible = false
          this.$refs.table.refresh(true)
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    }
  }
}
</script>

<style scoped>

</style>